import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useSentry } from '../hooks';
function SentryWrapper(_a) {
    var children = _a.children;
    useSentry();
    return _jsx(_Fragment, { children: children });
}
export function Sentry(_a) {
    var children = _a.children;
    if (process.env.REACT_APP_SENTRY_DSN)
        return _jsx(SentryWrapper, { children: children });
    console.log('%c Sentry disabled ', 'background: #15a1d9; color: #fff');
    return _jsx(_Fragment, { children: children });
}
